export default "__VITE_ASSET__d2b2e710__"